import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Harmless `AbortError: signal is aborted without reason` is dispatched when
// an AbortController is aborted mid-flight — lottie-web on unmount, and the
// Feed's video prefetch when you scroll quickly. These are already caught in
// our own code, but CRA's react-error-overlay registers its window listeners
// first, so a plain bubble-phase preventDefault runs too late and the red
// "Uncaught runtime errors" overlay still flashes. We register in the CAPTURE
// phase and call stopImmediatePropagation() so our handler runs BEFORE the
// overlay's and stops it from ever seeing the event. Only AbortError is
// swallowed — every real error still surfaces.
if (typeof window !== "undefined") {
  const isAbort = (x) =>
    x?.name === "AbortError" ||
    (typeof x?.message === "string" && x.message.includes("aborted without reason"));

  window.addEventListener(
    "unhandledrejection",
    (event) => {
      if (isAbort(event.reason)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true,
  );
  window.addEventListener(
    "error",
    (event) => {
      if (isAbort(event.error) || isAbort(event)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true,
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
